import { useTranslation } from "react-i18next";

import { useWeekConfig } from "../utils/weekConfig";

export const useWeekdayOrder = () => {
  const { t } = useTranslation();
  const { weekStart } = useWeekConfig();

  // Create dynamic weekdays array based on user's week start preference
  const getOrderedWeekdays = () => {
    const allDays = [
      { key: "sunday", label: t("sun") },
      { key: "monday", label: t("mon") },
      { key: "tuesday", label: t("tue") },
      { key: "wednesday", label: t("wed") },
      { key: "thursday", label: t("thu") },
      { key: "friday", label: t("fri") },
      { key: "saturday", label: t("sat") },
    ];

    const startIndex = allDays.findIndex(day => day.key === weekStart);
    return [...allDays.slice(startIndex), ...allDays.slice(0, startIndex)];
  };

  // Get weekParse object for the current week order
  const getWeekParse = () => {
    const orderedDays = getOrderedWeekdays();
    const weekParse = {};
    orderedDays.forEach((day, index) => {
      weekParse[day.key] = index;
    });
    return weekParse;
  };

  // Get short labels for weekdays (for monthly view)
  const getOrderedWeekDaysShort = () => {
    const allDaysShort = [
      { key: "sunday", label: "Sun" },
      { key: "monday", label: "Mon" },
      { key: "tuesday", label: "Tue" },
      { key: "wednesday", label: "Wed" },
      { key: "thursday", label: "Thu" },
      { key: "friday", label: "Fri" },
      { key: "saturday", label: "Sat" },
    ];

    const startIndex = allDaysShort.findIndex(day => day.key === weekStart);
    return [
      ...allDaysShort.slice(startIndex),
      ...allDaysShort.slice(0, startIndex),
    ];
  };

  return {
    getOrderedWeekdays,
    getWeekParse,
    getOrderedWeekDaysShort,
    orderedWeekdays: getOrderedWeekdays(),
    weekParse: getWeekParse(),
    orderedWeekDaysShort: getOrderedWeekDaysShort(),
  };
};
